import { Modal, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function TopFaqsModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  const questionsData = t('topFaqsModalData', { returnObjects: true });

  return (
    <Modal
      size="sm"
      title={t('topFAQs')}
      isOpen={isOpen}
      onRequestClose={onClose}
      primaryButtonProps={{
        children: t('okay'),
        onClick: onClose
      }}
    >
      <S.TopFaqsQuestions>
        {questionsData.map(question => (
          <S.TopFaqsQuestion key={question.question}>
            <Typography variant="body1Bold">{question.question}</Typography>
            <Typography>{question.answer}</Typography>
          </S.TopFaqsQuestion>
        ))}
      </S.TopFaqsQuestions>
    </Modal>
  );
}

export { TopFaqsModal };

TopFaqsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
